import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckSquare, MessageCircle, Activity, Gift, ArrowRight } from 'lucide-react';
export function OfferStackSection() {
  const bonuses = [{
    title: 'Bono #1 — Plan de 7 días (imprimible)',
    desc: 'Rutina diaria + misiones presencial y virtual + tracker'
  }, {
    title: 'Bono #2 — Checklist de Presencia Masculina',
    desc: 'Postura, voz, límites, energía, presencia en redes (IG/FB/TikTok)'
  }, {
    title: 'Bono #3 — Anti-Ansiedad Social (5 pasos)',
    desc: 'Protocolo rápido para cortar sobrepensamiento y entrar en calma'
  }, {
    title: 'Bono #4 — Errores Silenciosos (15 cosas)',
    desc: 'Lo que te baja atractivo sin darte cuenta y cómo corregirlo con clase'
  }];
  return <section id="offer" className="py-24 px-4 bg-bg-primary" data-id="element-129">
      <div className="container max-w-4xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-131">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-text-primary mb-4" data-id="element-132">
            Qué recibes al comprar
          </h2>
          <p className="text-text-secondary" data-id="element-133">
            Todo lo que necesitas para transformar tu presencia
          </p>
        </motion.div>

        {/* Main Product */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-bg-card border border-border-color rounded-2xl p-8 md:p-12 mb-12 relative overflow-hidden" data-id="element-134">
          <div className="absolute top-0 right-0 bg-cta-primary text-cta-text font-bold px-4 py-2 rounded-bl-xl text-sm uppercase tracking-wide" data-id="element-135">
            Producto Principal
          </div>

          <div className="flex flex-col md:flex-row gap-8 items-start" data-id="element-136">
            <div className="w-full md:w-1/3 aspect-[3/4] rounded-lg overflow-hidden border border-border-color shadow-2xl bg-bg-primary p-4" data-id="element-137">
              <img src="https://cdn.magicpatterns.com/uploads/gcDE415dxjofZbU5P9Merg/ChatGPT_Image_7_ene_2026,_04_49_45_p.m..png" alt="El Método Magnético - Portada del Ebook" className="w-full h-full object-contain" data-id="element-138" />
            </div>

            <div className="flex-1" data-id="element-139">
              <div className="flex items-center justify-between mb-2" data-id="element-140">
                <h3 className="text-2xl font-heading font-bold text-text-primary" data-id="element-141">
                  Ebook El Método Magnético
                </h3>
                <span className="text-lg font-bold text-text-secondary" data-id="element-142">
                  $25
                </span>
              </div>
              <p className="text-accent text-sm font-medium mb-6 uppercase tracking-wider" data-id="element-143">
                PDF + Acceso Inmediato
              </p>

              <ul className="space-y-4" data-id="element-144">
                {[{
                icon: Activity,
                text: 'Framework completo: Energía + Estructura + Señales'
              }, {
                icon: CheckSquare,
                text: 'Ejercicios diarios (plan 7 días)'
              }, {
                icon: CheckSquare,
                text: 'Checklist: qué hacer / qué evitar'
              }, {
                icon: MessageCircle,
                text: 'Guía de situaciones comunes (en persona + social)'
              }, {
                icon: MessageCircle,
                text: 'Sección práctica de chat IG/FB: responder historias, iniciar, mantener, escalar con clase'
              }, {
                icon: Activity,
                text: 'Sección energía: caminar, ejercicio, comer bien, meditar, dormir (calma real)'
              }].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-145">
                    <item.icon className="w-5 h-5 text-cta-primary mt-1 flex-shrink-0" data-id="element-146" />
                    <span className="text-text-normal" data-id="element-147">{item.text}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* Bonuses */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-148">
          {bonuses.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-bg-card/50 border border-border-color rounded-xl p-6 hover:bg-bg-card transition-colors" data-id="element-149">
              <div className="flex items-center justify-between mb-3" data-id="element-150">
                <div className="flex items-center space-x-2 text-urgency" data-id="element-151">
                  <Gift className="w-5 h-5" data-id="element-152" />
                  <span className="font-bold text-sm uppercase tracking-wide" data-id="element-153">
                    Gratis hoy
                  </span>
                </div>
                <span className="text-sm font-bold text-text-secondary" data-id="element-154">
                  $15
                </span>
              </div>
              <h4 className="text-lg font-bold text-text-primary mb-2" data-id="element-155">
                {bono.title}
              </h4>
              <p className="text-text-secondary text-sm" data-id="element-156">{bono.desc}</p>
            </motion.div>)}
        </div>

        {/* Value Summary */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-card border-2 border-cta-primary/50 rounded-2xl p-8 mb-8" data-id="element-157">
          <div className="text-center" data-id="element-158">
            <p className="text-text-secondary text-sm mb-4 uppercase tracking-wider" data-id="element-159">
              Valor Total del Paquete
            </p>
            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-160">
              <span className="text-3xl md:text-4xl font-heading font-bold text-text-secondary line-through opacity-60" data-id="element-161">
                $85
              </span>
              <span className="text-5xl md:text-6xl font-heading font-extrabold text-cta-primary" data-id="element-162">
                $6.99
              </span>
            </div>
            <p className="text-urgency font-bold text-lg mb-2" data-id="element-163">
              ¡Ahorrás $78.01 HOY!
            </p>
            <p className="text-text-secondary text-sm" data-id="element-164">
              Más del 90% de descuento - Oferta por tiempo limitado
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center bg-cta-primary/10 border border-cta-primary/20 rounded-lg p-4" data-id="element-165">
          <p className="text-cta-primary font-medium flex items-center justify-center gap-2" data-id="element-166">
            <ArrowRight className="w-5 h-5" data-id="element-167" />
            Acceso inmediato al contenido + bonos al confirmar tu compra.
          </p>
        </motion.div>
      </div>
    </section>;
}